import { jsx } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { useState, useMemo, useLayoutEffect } from "react";
import { useCloseOnEscape, useCloseOnClickOutside } from "../../auxiliary/useCloseOnEscapeOrClickOutside.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { Box } from "../Box/Box.js";
const Dialog = (props) => {
  const componentClassName = useClassNameFactory("dialog");
  const [contentElement, setContentElement] = useState(null);
  const [overlayElement, setOverlayElement] = useState(null);
  const {
    resolve,
    settings: { bare, content: Content, footer: Footer, gap = true, heading, type }
  } = props.settings;
  useCloseOnEscape({ isOpen: true, close: resolve });
  useCloseOnClickOutside({ isOpen: true, close: resolve, contents: useMemo(() => [contentElement], [contentElement]), outside: overlayElement });
  useLayoutEffect(() => {
    if (!contentElement) {
      return;
    }
    contentElement.focus();
  }, [contentElement]);
  return /* @__PURE__ */ jsx("div", { className: componentClassName("", toEnumViewClass(type)), ref: setOverlayElement, children: /* @__PURE__ */ jsx("div", { className: componentClassName("in"), ref: setContentElement, children: /* @__PURE__ */ jsx(
    Box,
    {
      border: !bare,
      padding: !bare,
      gap,
      label: heading,
      footer: Footer ? /* @__PURE__ */ jsx(Footer, { resolve }) : null,
      children: /* @__PURE__ */ jsx(Content, { resolve })
    }
  ) }) });
};
export {
  Dialog
};
//# sourceMappingURL=Dialog.js.map
